import { render, staticRenderFns } from "./chanceManagement.vue?vue&type=template&id=35dc51d6&scoped=true"
import script from "./chanceManagement.vue?vue&type=script&lang=js"
export * from "./chanceManagement.vue?vue&type=script&lang=js"
import style0 from "./chanceManagement.vue?vue&type=style&index=0&id=35dc51d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc51d6",
  null
  
)

export default component.exports